import PropTypes from 'prop-types';
import uniqid from 'uniqid';
import { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as PriceOfferListActions from '../../redux/actions/priceOfferListActions';
import { selectSortedAndFilteredPackages } from '../../redux/selectors/priceOfferListSelectors';
import PriceOfferListLoader from '../shared/priceOfferListLoader';
import PriceOfferListCard from './priceOfferListCard';
import SortPanel from '../shared/sortPanel';
import FilterPanel from '../shared/filterComponents/filterPanel';
import './priceOfferListContainer.scss';
import sortOrderTypes from '../../constants/sortOrderTypes';

const PriceOfferListContainer = (props) => {
  const {
    priceOfferSearchInfo,
    presentationSettings,
    labels,
    priceOfferList,
    sortedAndFilteredPackages,
    init,
    setSortOrder,
    sortOrder,
  } = props;
  const { isLoading } = priceOfferList;
  const { siteId, isCharter, imageDomain } = priceOfferSearchInfo;
  const { showFilterAndSorting, discountType, buttonText, defaultSortOrder } =
    presentationSettings;

  // Use an empty dependency array because we need to fetch price offer list packages only once when the component mounts.
  useEffect(() => {
    init(priceOfferSearchInfo, defaultSortOrder);
  }, []);

  if (isLoading) {
    return <PriceOfferListLoader />;
  }

  const sortOrders = [
    {
      sortOrder: sortOrderTypes.earliestDate,
      label: labels.sortLabels.earliestDate,
    },
    {
      sortOrder: sortOrderTypes.lowestPrice,
      label: labels.sortLabels.lowestPrice,
    },
    {
      sortOrder: sortOrderTypes.highestRating,
      label: labels.sortLabels.highestRating,
    },
    {
      sortOrder: sortOrderTypes.highestDiscount,
      label: labels.sortLabels.highestDiscount,
    },
  ];

  return (
    <div className="po-list-container">
      {(showFilterAndSorting === 'true' || showFilterAndSorting === true) && (
        <div className="po-list-sort-and-filter-wrapper">
          <FilterPanel
            siteId={siteId}
            labels={labels?.filterLabels}
            numberOfVisiblePackages={sortedAndFilteredPackages?.length}
          />
          <SortPanel
            sortOrder={sortOrder}
            labels={labels?.sortLabels}
            sortOrders={sortOrders}
            setSortOrder={setSortOrder}
          />
        </div>
      )}
      {sortedAndFilteredPackages?.map((priceOfferPackage, index) => {
        return (
          <PriceOfferListCard
            key={uniqid('po-list-card-')}
            index={index}
            priceOfferPackage={priceOfferPackage}
            siteId={siteId}
            discountType={discountType}
            buttonText={buttonText || priceOfferPackage.buttonText}
            isCharter={isCharter}
            imageDomain={imageDomain}
          />
        );
      })}
    </div>
  );
};

PriceOfferListContainer.propTypes = {
  priceOfferSearchInfo: PropTypes.shape({
    apiUrl: PropTypes.string.isRequired,
    priceOfferId: PropTypes.number.isRequired,
    userId: PropTypes.string.isRequired,
    isCharter: PropTypes.bool.isRequired,
    siteId: PropTypes.number.isRequired,
    imageDomain: PropTypes.string.isRequired,
  }).isRequired,
  presentationSettings: PropTypes.shape({
    discountType: PropTypes.string,
    buttonText: PropTypes.string,
    showFilterAndSorting: PropTypes.bool.isRequired,
    defaultSortOrder: PropTypes.string,
  }).isRequired,
  labels: PropTypes.shape({
    sortLabels: PropTypes.shape().isRequired,
    filterLabels: PropTypes.shape().isRequired,
    lowestPrice: PropTypes.string.isRequired,
    earliestDate: PropTypes.string.isRequired,
    highestRating: PropTypes.string.isRequired,
    highestDiscount: PropTypes.string.isRequired,
  }).isRequired,
  priceOfferList: PropTypes.shape({
    isLoading: PropTypes.bool.isRequired,
    packages: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  }).isRequired,
  sortedAndFilteredPackages: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  init: PropTypes.func.isRequired,
  setSortOrder: PropTypes.func.isRequired,
  sortOrder: PropTypes.string.isRequired,
};

const mapDispatchToProps = (dispatch) => {
  return {
    init: bindActionCreators(PriceOfferListActions.init, dispatch),
    setSortOrder: bindActionCreators(
      PriceOfferListActions.setSortOrder,
      dispatch,
    ),
  };
};

const mapStateToProps = (state) => {
  return {
    priceOfferList: state.priceOfferList,
    sortedAndFilteredPackages: selectSortedAndFilteredPackages(state),
    sortOrder: state.sort.sortOrder,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PriceOfferListContainer);
